import React from 'react';
import { Stack } from '@mui/material';
import { StepTitle } from '../StepTitle';
import { StepIndicatorStates } from 'components/StepIndicator';
import { useIntl } from 'react-intl';
import { ContactDetailsStepActive } from './ContactDetailsStepActive';
import { ClientContactInformation } from 'modules/contract/types';

interface ContactDetailsStepProps {
  state: StepIndicatorStates
  completeStep(clientContactInformation: ClientContactInformation): void
}

export const ContactDetailsStep: React.FC<ContactDetailsStepProps> = ({ state, completeStep }) => {
  const { formatMessage } = useIntl();

  return (
    <Stack gap={5}>
      <StepTitle
        number={4}
        state={state}
        activeTitle={formatMessage({ id: 'FindServiceCall.ContactDetailsStep.ActiveTitle', defaultMessage: 'Enter your contact details' })}
        incompleteTitle={formatMessage({ id: 'FindServiceCall.ContactDetailsStep.IncompleteTitle', defaultMessage: 'Your contact details' })}
        completedTitle=""
      />
      {state === 'active' && <ContactDetailsStepActive completeStep={completeStep} />}
    </Stack>
  );
};